import { useNavigate } from "react-router-dom";
import parse from "html-react-parser";

const BlogsCard = ({ el, month, date }) => {
  const navigate = useNavigate();

  // Helper to safely extract text from HTML string for brief summary
  const getTextSummary = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.length > 100 ? text.substring(0, 100) + "..." : text;
  };

  return (
    <div
      key={el._id}
      className="p-8 border border-black dark:border-white/30 bg-white dark:bg-black text-black dark:text-white cursor-pointer group flex flex-col justify-between"
      onClick={() => navigate(`/blogs/${el._id}`)}
    >
      <div>
        <div className="flex justify-between items-start mb-6">
          <span className="border border-black dark:border-white/30 px-2 py-1 text-[10px] font-mono font-bold uppercase tracking-widest bg-white dark:bg-black text-black dark:text-white ">
            {month} {date}
          </span>
          {el.categories && el.categories.length > 0 && (
            <span className="text-[10px] font-mono tracking-widest text-black dark:text-white uppercase font-bold bg-gray-100 dark:bg-[#111] border border-black dark:border-white/30  px-2 py-1 transition-colors">
              {el.categories.map((c) => c.name).join(" / ")}
            </span>
          )}
        </div>
        <h1 className="text-3xl font-black uppercase tracking-tight leading-[0.9] mb-6 group-hover:underline underline-offset-4 line-clamp-3">
          {el.title}
        </h1>
        <div className="font-mono text-xs leading-relaxed mb-8 text-gray-700 dark:text-gray-400 line-clamp-3">
          {parse(getTextSummary(el.body))}
        </div>
      </div>

      <div className="flex items-center mt-auto border-t border-black dark:border-white/30 pt-4 transition-colors">
        <img
          alt="author avatar"
          src={el.user?.avatar}
          className="w-10 h-10 filter grayscale group-hover:grayscale-0 rounded-none border border-black dark:border-white/30 object-cover transition-colors"
        />
        <div className="flex flex-col ml-3">
          <span className="font-mono text-[10px] tracking-widest uppercase font-bold text-black dark:text-white leading-none mb-1 transition-colors">
            {el.user?.name || "OP-UNKNOWN"}
          </span>
          <span className="font-mono text-[8px] tracking-widest text-gray-500 dark:text-gray-400 transition-colors">
            AUTHOR ID: {el.user?._id ? el.user._id.substring(0, 6) : "OP-0X"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BlogsCard;
